import { Brand } from 'domains/brand';

export const brandInitialState = {
  sac: {
    whatsapp: '',
    phone: '',
    portalLink: '',
    portalName: '',
    hours: {
      whatsapp: '',
      phone: '',
      portal: '',
    },
  },
} as Brand;
